import React from "react";
import { FieldArray, FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { TrainerFormValues } from "src/models/Trainer.model";
import ATMDatePicker from "src/components/UI/atoms/formFields/ATMDatePicker/ATMDatePicker";
import moment from "moment";
import ATMSelectValue from "src/components/UI/atoms/formFields/ATMSelectValue/ATMSelectValue";
import ATMRadioButton from "src/components/UI/atoms/ATMRadioButton/ATMRadioButton";
import ATMTextArea from "src/components/UI/atoms/formFields/ATMTextArea/ATMTextArea";
import { AiOutlinePlus } from "react-icons/ai";
import ATMCheckbox from "src/components/UI/atoms/formFields/ATMCheckbox/ATMCheckbox";
import { MdDelete } from "react-icons/md";
import { useLocation } from "react-router-dom";
import { handleValidNumber } from "src/utils/validations/numberInput";
import { showConfirmationDialog } from "src/utils/showConfirmationDialog";
import useBranches from "src/hooks/useGetBranches";
import ATMMultiSelect from "src/components/UI/atoms/formFields/ATMMultiSelect/ATMMultiSelect";
type Props = {
  formikProps: FormikProps<TrainerFormValues>;
};

const GenderOption = [
  {
    label: "Female",
    value: "FEMALE",
  },
  {
    label: "Male",
    value: "MALE",
  },
  {
    label: "Other",
    value: "OTHER",
  },
];
const MaritalStatusOption = [
  {
    label: "Single",
    value: "SINGLE",
  },
  {
    label: "Married",
    value: "MARRIED",
  },
  {
    label: "Separate",
    value: "SEPARATE",
  },
];

const CourseOption = [
  {
    label: "Tech",
    value: "TECH",
  },
  {
    label: "Non-Tech",
    value: "NON_TECH",
  },
];
const CollegeTearOption = [
  {
    label: "Tier One",
    value: "TIER_ONE",
  },
  {
    label: "Tier Two",
    value: "TIER_TWO",
  },
  {
    label: "Tier Three",
    value: "TIER_THREE",
  },
];

const TrainerForm = ({ formikProps }: Props) => {
  const location = useLocation();
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;
  const currentPath = `/${location.pathname?.split("/")[2]}`;

  //   Get All Branched
  const { branches, isDataLoading: isBranchLoading } = useBranches();

  const generatePassword = (name:any) => {
    var randomChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$";
  var password = name.slice(0, 3); // Take the first three letters of the name

  // Append two random characters
  for (var i = 0; i < 5; i++) {
    var randomIndex = Math.floor(Math.random() * randomChars.length);
    password += randomChars.charAt(randomIndex);
  }

  return setFieldValue('password' , password) ;
  };

  return (
    <div className="">
      <div className="flex flex-col gap-6 font-semibold text-lg pb-2 pl-4 pt-2 bg-white z-50 sticky top-0">
        {currentPath === "/edit" ? "Edit" : "Add"} Form
      </div>
      <div className="p-4">
        <div className="border-l-[3px] border-primary-dark px-3 py-1 mb-2 font font-medium text-[18px] sticky top-0 bg-white  text-primary-dark">
          Personal Information
        </div>
        <div className="grid xl:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-4 pl-2">
          {/* Trainer Name */}
          <div>
            <ATMTextField
              name="trainer_name"
              value={values.trainer_name}
              onChange={(e) => {
                setFieldValue("trainer_name", e.target.value);
              }}
              label="Trainer Name"
              placeholder="Enter trainer Name"
              onBlur={handleBlur}
            />
          </div>
          {/* Mobile */}
          <div>
            <ATMTextField
              name="mobile_number"
              value={values.mobile_number}
              onChange={(e) => {
                handleValidNumber(e, { forMobile: true }) &&
                  setFieldValue("mobile_number", e.target.value);
              }}
              label="Mobile"
              onBlur={handleBlur}
              placeholder="Enter Mobile number"
            />
          </div>
          {/*Whatsapp Number */}
          <div>
            <ATMTextField
              name="whatsapp_number"
              value={values.whatsapp_number}
              onChange={(e) => {
                handleValidNumber(e, { forMobile: true }) &&
                  setFieldValue("whatsapp_number", e.target.value);
              }}
              label="Whatsapp Number"
              placeholder="Enter Whatsapp number"
              onBlur={handleBlur}
            />
          </div>
          {/* Emergency Contact Details */}
          <div>
            <ATMTextField
              name="emergency_contact_number"
              value={values.emergency_contact_number}
              onChange={(e) => {
                handleValidNumber(e, { forMobile: true }) &&
                  setFieldValue("emergency_contact_number", e.target.value);
              }}
              label="Emergency Contact number"
              placeholder="Enter Emergency number"
              onBlur={handleBlur}
            />
          </div>
          {/* DOB */}
          <div>
            <ATMDatePicker
              name="dob"
              views={["day", "month", "year"]}
              value={values.dob}
              onChange={(newValue) => setFieldValue("dob", newValue)}
              label="DOB"
              maxDate={moment().format("yyyy-MM-DD")}
            />
          </div>
          {/* Email */}
          <div>
            <ATMTextField
              name="email"
              value={values.email}
              onChange={(e) => {
                setFieldValue("email", e.target.value);
              }}
              label="Email"
              placeholder="Enter Email "
              onBlur={handleBlur}
            />
          </div>
          {/* address */}
          <div>
            <ATMTextField
              name="address"
              value={values.address}
              onChange={(e) => {
                setFieldValue("address", e.target.value);
              }}
              label="Address "
              onBlur={handleBlur}
              placeholder="Enter address "
            />
          </div>
          {/* Branch Name */}
          <div>
            <ATMMultiSelect
              name="branchId"
              value={values.branchId}
              label="Branch"
              placeholder="Select branch"
              isLoading={isBranchLoading}
              options={branches?.map((branch: any) => ({
                label: branch?.branchName,
                value: branch?._id,
              }))}
              onChange={(newValue) => setFieldValue("branchId", newValue)}
              onBlur={handleBlur}
            />
          </div> 
          {currentPath !== "/edit" &&  <div className=" relative ">
          <ATMTextField
            name="password"
            required
            value={values?.password}
            onChange={(e) => {
              setFieldValue("password", e.target.value);
            }}
            label="Password"
            placeholder="Enter Password"
            onBlur={handleBlur}
          />
          <div className="absolute top-7 right-2">
            <button
            disabled={!values?.trainer_name}
              className="bg-primary-dark p-1 text-white font-semibold rounded-md text-[15px]"
              type="button"
              onClick={() => {
                generatePassword(values?.trainer_name);
              }}
            >
              Generate
            </button>
          </div>
        </div>}
         
          {/* Gender */}

          <div>
            <ATMRadioButton
              label="Gender"
              name="gender"
              value={values?.gender || ""}
              className="mt-1 flex"
              options={GenderOption}
              onChange={(e) => {
                setFieldValue("gender", e);
              }}
            />
          </div>
          {/*  Blood Group */}
          <div>
            <ATMTextField
              name="blood_group"
              value={values.blood_group}
              onChange={(e) => {
                setFieldValue("blood_group", e.target.value);
              }}
              label=" Blood Group "
              onBlur={handleBlur}
              placeholder="Enter Blood group "
            />
          </div>
          {/* Marital */}
          <div>
            <ATMRadioButton
              label="Marital Status"
              name="marital"
              value={values?.marital || ""}
              className="mt-1 flex"
              options={MaritalStatusOption}
              onChange={(e) => {
                setFieldValue("marital", e);
              }}
            />
          </div>
        </div>
        <div className="my-4">
          <div className="border-l-[3px] border-primary-dark px-3 py-1  font font-medium text-[18px] sticky top-0 bg-white  text-primary-dark">
            Academic History
          </div>
          <div className="mt-1">
            <FieldArray
              name="academic_history"
              render={({ push, remove }) => (
                <>
                  {values?.academic_history?.map((doc: any, index: any) => {
                    return (
                      <div key={index}>
                        <div className="flex justify-end mt-3">
                          <MdDelete
                            color="#F70913"
                            size={30}
                            className="pl-1 cursor-pointer"
                            onClick={() => {
                              showConfirmationDialog({
                                title: "Heads Up",
                                text: "Are you sure want to Delete this Academic History?",
                                icon: "question",
                                showCancelButton: true,
                                next: (result) => {
                                  if (result.isConfirmed) {
                                    remove(index);
                                  }
                                },
                              });
                            }}
                          />
                        </div>
                        <div className="grid xl:grid-cols-4 md:grid-cols-2 grid-cols-1 xl:gap-6 gap-4 items-center">
                          <div>
                            <div>
                              <ATMTextField
                                name={`academic_history[${index}].collge_school_name`}
                                value={
                                  values?.academic_history?.[index]
                                    ?.collge_school_name
                                }
                                onChange={(e) =>
                                  setFieldValue(
                                    `academic_history[${index}].collge_school_name`,
                                    e.target.value
                                  )
                                }
                                label="College School Name"
                                placeholder="Enter College School Name"
                                onBlur={handleBlur}
                              />
                            </div>
                          </div>
                          <div>
                            <ATMTextField
                              name={`academic_history[${index}].course_name`}
                              value={
                                values?.academic_history?.[index]?.course_name
                              }
                              onChange={(e) =>
                                setFieldValue(
                                  `academic_history[${index}].course_name`,
                                  e.target.value
                                )
                              }
                              label="Course Name"
                              placeholder="Enter Course Name"
                              onBlur={handleBlur}
                            />
                          </div>
                          {/* Course Type */}
                          <div className="">
                            <ATMSelectValue
                              name={`academic_history[${index}].course_type`}
                              value={
                                values?.academic_history?.[index]?.course_type
                              }
                              onChange={(newValue) =>
                                setFieldValue(
                                  `academic_history[${index}].course_type`,
                                  newValue
                                )
                              }
                              onBlur={handleBlur}
                              label="Course Type"
                              placeholder="Select Course Type"
                              options={CourseOption}
                            />
                          </div>
                          {/* Course Tier */}
                          <div className="">
                            <ATMSelectValue
                              name={`academic_history[${index}].collge_school_tier`}
                              value={
                                values?.academic_history?.[index]
                                  ?.collge_school_tier
                              }
                              onChange={(newValue) =>
                                setFieldValue(
                                  `academic_history[${index}].collge_school_tier`,
                                  newValue
                                )
                              }
                              onBlur={handleBlur}
                              label="College School Tier"
                              placeholder="Select College School Tier"
                              options={CollegeTearOption}
                            />
                          </div>
                          {/* ATMDATEPICKER */}
                          <div>
                            <ATMDatePicker
                              views={["year"]}
                              format="YYYY"
                              name={`academic_history[${index}].start_year`}
                              value={
                                values?.academic_history?.[index]?.start_year ||
                                null
                              }
                              onChange={(newValue) =>
                                setFieldValue(
                                  `academic_history[${index}].start_year`,
                                  newValue
                                )
                              }
                              label="Start Year"
                            />
                          </div>
                          <div>
                            <ATMDatePicker
                              views={["year"]}
                              format="YYYY"
                              name={`academic_history[${index}].end_year`}
                              value={
                                values?.academic_history?.[index]?.end_year ||
                                null
                              }
                              onChange={(newValue) =>
                                setFieldValue(
                                  `academic_history[${index}].end_year`,
                                  newValue
                                )
                              }
                              label="End Year"
                            />
                          </div>
                          <div className="mt-6">
                            <ATMCheckbox
                              value={
                                values?.academic_history?.[index]
                                  ?.currently_pursuing
                              }
                              name={`academic_history[${index}].currently_pursuing`}
                              extraClasses="font-semibold"
                              checked={
                                values?.academic_history?.[index]
                                  ?.currently_pursuing
                              }
                              onChange={(e) =>
                                setFieldValue(
                                  `academic_history[${index}].currently_pursuing`,
                                  e
                                )
                              }
                              label="Currently Pursuing"
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  <div className="flex justify-end my-4">
                    <p
                      className="text-link font-semibold text-base text-[16px] max-[1024px]:text-sm flex items-center cursor-pointer"
                      onClick={() =>
                        push({
                          collge_school_name: "",
                          course_name: "",
                          end_year: "",
                          start_year: "",
                          course_type: "",
                          collge_school_tier: "",
                        })
                      }
                    >
                      <AiOutlinePlus
                        size={18}
                        color="#0064C4"
                        className="mr-2"
                      />
                      Add Academic History
                    </p>
                  </div>
                </>
              )}
            />
          </div>
          <div className="border-l-[3px] border-primary-dark px-3 py-1  font font-medium text-[18px] sticky top-0 bg-white  text-primary-dark">
            Work History
          </div>
          <div className="mt-1">
            <FieldArray
              name="work_history"
              render={({ push, remove }) => (
                <>
                  {values?.work_history?.map((doc: any, index: any) => {
                    return (
                      <div key={index}>
                        <div className="flex justify-end mt-3">
                          <MdDelete
                            color="#F70913"
                            size={30}
                            className="pl-1 cursor-pointer"
                            onClick={() => {
                              showConfirmationDialog({
                                title: "Heads Up",
                                text: "Are you sure want to Delete this Work History?",
                                icon: "question",
                                showCancelButton: true,
                                next: (result) => {
                                  if (result.isConfirmed) {
                                    remove(index);
                                  }
                                },
                              });
                            }}
                          />
                        </div>
                        <div className="grid xl:grid-cols-4 md:grid-cols-2 grid-cols-1 xl:gap-6 gap-4 items-center">
                          <div>
                            <ATMTextField
                              name={`work_history[${index}].company_name`}
                              value={
                                values?.work_history?.[index]?.company_name
                              }
                              onChange={(e) =>
                                setFieldValue(
                                  `work_history[${index}].company_name`,
                                  e.target.value
                                )
                              }
                              label="Company Name"
                              placeholder="Enter Company Name"
                              onBlur={handleBlur}
                            />
                          </div>
                          <div>
                            <ATMTextField
                              name={`work_history[${index}].job_title`}
                              value={values?.work_history?.[index]?.job_title}
                              onChange={(e) =>
                                setFieldValue(
                                  `work_history[${index}].job_title`,
                                  e.target.value
                                )
                              }
                              label="Job Title"
                              placeholder="Enter Job Title"
                              onBlur={handleBlur}
                            />
                          </div>

                          <div>
                            <ATMDatePicker
                              views={["year"]}
                              format="YYYY"
                              name={`work_history[${index}].start_year`}
                              value={
                                values?.work_history?.[index]?.start_year ||
                                null
                              }
                              onChange={(newValue) =>
                                setFieldValue(
                                  `work_history[${index}].start_year`,
                                  newValue
                                )
                              }
                              label="Start Year"
                            />
                          </div>
                          <div>
                            <ATMDatePicker
                              views={["year"]}
                              format="YYYY"
                              name={`work_history[${index}].end_year`}
                              value={
                                values?.work_history?.[index]?.end_year || null
                              }
                              onChange={(newValue) =>
                                setFieldValue(
                                  `work_history[${index}].end_year`,
                                  newValue
                                )
                              }
                              label="End Year"
                            />
                          </div>
                        </div>

                        <div className="mt-4">
                          <ATMTextArea
                            name={`work_history[${index}].job_description`}
                            value={
                              values?.work_history?.[index]?.job_description
                            }
                            onChange={(e) =>
                              setFieldValue(
                                `work_history[${index}].job_description`,
                                e
                              )
                            }
                            label="Job Description"
                            placeholder="Enter Job Description"
                            onBlur={handleBlur}
                          />
                        </div>

                        <div className="mt-4">
                          <ATMCheckbox
                            name={`work_history[${index}].currently_pursuing`}
                            value={
                              values?.work_history?.[index]?.currently_pursuing
                            }
                            extraClasses="font-semibold"
                            checked={
                              values?.work_history?.[index]?.currently_pursuing
                            }
                            onChange={(e) =>
                              setFieldValue(
                                `work_history[${index}].currently_pursuing`,
                                e
                              )
                            }
                            label="Currently Working"
                          />
                        </div>
                      </div>
                    );
                  })}
                  <div className="flex justify-end my-4">
                    <p
                      className="text-link font-semibold text-base text-[16px] max-[1024px]:text-sm flex items-center cursor-pointer"
                      onClick={() =>
                        push({
                          company_name: "",
                          job_description: "",
                          job_title: "",
                          end_year: "",
                          start_year: "",
                        })
                      }
                    >
                      <AiOutlinePlus
                        size={18}
                        color="#0064C4"
                        className="mr-2"
                      />
                      Add Work History
                    </p>
                  </div>
                </>
              )}
            />
          </div>
        </div>

        <div className="flex justify-end">
          <div>
            <ATMLoadingButton
              className="px-6"
              isLoading={isSubmitting}
              type="submit"
            >
              Save
            </ATMLoadingButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrainerForm;
